import device from "current-device";
import Cookies from "js-cookie";

declare let userLoggedIn: string | null | undefined;
declare let dlPT: string;
declare let dlPU: string;
declare let dlPTy: string;
declare let dlSID: string;
declare let serverID: string;
declare let dlEH: string;
declare let dlFNH: string;
declare let dlLNH: string;
declare let dlGH: string;
declare let dlPH: string;
declare let dlZH: string;
declare let dlCCH: string;
declare let dlBDH: string;
declare let dlFN: string;
declare let dlG: string;
declare let dlBD: string;
declare let dlIPA: string;
declare let dataLayer: any[];
declare function queryStringValue(key: string): string;

declare global 
{
    interface Window 
    {
        device: typeof device;
    }
}
window.device = device;

let loginState = false;
let isZeroResultSearch = 0;
let pageNumber: string | number = 0;
let pageResults = 0;
let suggestionResults = 0;
let delayDataLayerSend = false;

const pageNumberElement = document.getElementById("currentPage") as HTMLInputElement | null;
const pageResultsElement = document.getElementById("results") as HTMLInputElement | null;

if (userLoggedIn != null && userLoggedIn.length > 0)
    loginState = true;

if (pageNumberElement != null)
    pageNumber = pageNumberElement.value;

if (pageResultsElement != null)
{
    const resultFound = document.getElementsByClassName("nosearchresults");
    if (resultFound != null && resultFound.length > 0)
    {
        suggestionResults = parseInt(pageResultsElement.value, 10) || 0;
        isZeroResultSearch = 1;
    }
    else
    {
        // Delay sending data until hash filter has been applied
        if (document.location.hash.length > 1)
            delayDataLayerSend = true;

        pageResults = parseInt(pageResultsElement.value, 10) || 0;
        if (pageResults === 0)
            isZeroResultSearch = 1;
    }

    if (Number.isNaN(pageResults))
        pageResults = 0;
}

const dataObject: Record<string, any> = {
    "pageTitle": dlPT,
    "pageUrl": dlPU,
    "pageType": dlPTy,
    "searchResultAmount": pageResults,
    "searchResultSuggestionsAmount": suggestionResults,
    "loginState": loginState,
    "UserID": userLoggedIn,
    "sessionID": dlSID,
    "matchingParams": [],
    "Server": serverID,
    "Paginanummer": pageNumber,
    "zeroResultSearch": isZeroResultSearch
};

let deviceType = "desktop";

if (device.mobile())
    deviceType = "phone";
else if (device.tablet())
    deviceType = "tablet";

interface UtmProfile
{
    utmCampaign: string;
    utmSource: string;
    utmMedium: string;
    utmContent: string;
    utmKeyword: string;
}

let utmWrapper: UtmProfile = {
    utmCampaign: "",
    utmSource: "",
    utmMedium: "",
    utmContent: "",
    utmKeyword: ""
};

if (queryStringValue("gclid").length > 0)
{
    const gclid = queryStringValue("gclid");
    utmWrapper.utmCampaign = gclid;
    utmWrapper.utmSource = "google";
    utmWrapper.utmMedium = "cpc";
}
else
{
    if (queryStringValue("utm_campaign").length > 0)
        utmWrapper.utmCampaign = queryStringValue("utm_campaign").trim();

    if (queryStringValue("utm_source").length > 0)
        utmWrapper.utmSource = queryStringValue("utm_source").trim();

    if (queryStringValue("utm_medium").length > 0)
        utmWrapper.utmMedium = queryStringValue("utm_medium").trim();

    if (queryStringValue("utm_content").length > 0)
        utmWrapper.utmContent = queryStringValue("utm_content").trim();

    if (queryStringValue("utm_keyword").length > 0)
        utmWrapper.utmKeyword = queryStringValue("utm_keyword").trim();
}

if (utmWrapper.utmCampaign.length === 0 || utmWrapper.utmSource.length === 0) 
{
    const utmJson = Cookies.get("utm-wrapper");
    if (utmJson !== undefined && utmJson !== null && utmJson !== "undefined")
        utmWrapper = JSON.parse(utmJson) as UtmProfile;
}
else
{
    const expirationDate = new Date();
    expirationDate.setMonth(expirationDate.getMonth() + 1);
    const utmJson = JSON.stringify(utmWrapper);
    Cookies.remove("utm-wrapper");
    Cookies.set("utm-wrapper", utmJson, { path: "/", expires: expirationDate });
}

if (deviceType.length > 0)
    dataObject["device"] = deviceType;

if (utmWrapper.utmCampaign.length > 0)
    dataObject["campaign"] = utmWrapper.utmCampaign;

if (utmWrapper.utmSource.length > 0)
    dataObject["source"] = utmWrapper.utmSource;

if (utmWrapper.utmMedium.length > 0)
    dataObject["medium"] = utmWrapper.utmMedium;

if (utmWrapper.utmContent.length > 0)
    dataObject["content"] = utmWrapper.utmContent;

if (utmWrapper.utmKeyword.length > 0)
    dataObject["keyword"] = utmWrapper.utmKeyword;

const matchingParams = [
    { key: "emailhash", value: dlEH },
    { key: "firstnamehash", value: dlFNH },
    { key: "lastnamehash", value: dlLNH },
    { key: "genderhash", value: dlGH },
    { key: "phonehash", value: dlPH },
    { key: "zipcodehash", value: dlZH },
    { key: "countryhash", value: dlCCH },
    { key: "birthdatehash", value: dlBDH },
    { key: "firstname", value: dlFN },
    { key: "gender", value: dlG },
    { key: "birthdate", value: dlBD },
    { key: "ipaddress", value: dlIPA }
];

const matchingParamsToSend: Record<string, string> = {};

for (let i = 0; i < matchingParams.length; i++)
{
    const key = matchingParams[i].key;
    const value = matchingParams[i].value;

    if (key !== undefined && key != null && key.length > 0 &&
        value !== undefined && value != null && value.length > 0)
        matchingParamsToSend[key] = value;
}

if (Object.keys(matchingParamsToSend).length > 0)
    dataObject["matchingParams"] = [matchingParamsToSend];

if (!delayDataLayerSend)
    dataLayer.push(dataObject);

if (userLoggedIn != null && userLoggedIn.length > 0)
    dataLayer.push("userId", userLoggedIn);